import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useDebounce } from '@/hooks/useDebounce';

interface ContactSearchResult {
  id: string;
  first_name: string | null;
  last_name: string | null;
  primary_email: string | null;
  primary_phone: string | null;
}

export function useContactSearch(searchQuery: string, limit = 50) {
  const debouncedSearch = useDebounce(searchQuery, 300);

  const { data: contacts = [], isLoading: loading } = useQuery({
    queryKey: ['contacts-search', debouncedSearch, limit],
    queryFn: async () => {
      if (!debouncedSearch || debouncedSearch.trim().length < 1) return [];
      const { data, error } = await supabase
        .rpc('search_contacts_unaccent', {
          search_term: debouncedSearch.trim(),
          max_results: limit,
        });
      if (error) throw error;
      return (data || []) as ContactSearchResult[];
    },
    enabled: !!debouncedSearch && debouncedSearch.trim().length >= 1,
  });

  return { contacts, loading };
}
